<script lang="ts">
	import type { ICoinDetails } from 'customTypes/coinDetails';
	import AddToWatchList from 'components/AddToWatchList/AddToWatchList.svelte';
	import CoinInfo from 'components/CoinInfo/CoinInfo.svelte';
	import Converter from 'components/Converter/Converter.svelte';
	import MarketStatistic from 'components/MarketStatistic/MarketStatistic.svelte';
	import CoinPageSearch from 'components/CoinSearch/CoinSearch.svelte';

	export let dark: boolean;
	export let data: ICoinDetails;
</script>

<section class="coin-data container" class:dark>
	<div class="stats"><CoinInfo {dark} {data} /></div>
	<div class="search"><CoinPageSearch {dark} minWidth={100} /></div>
	<div class="add-to-list"><AddToWatchList {dark} id={data.stats.id} /></div>
	<div class="convertor"><Converter {dark} data={data.stats} /></div>
	<div class="market-data"><MarketStatistic {dark} {data} /></div>
</section>

<style lang="scss">
	@import 'cryptoStatSection';
</style>
